<div class="user-manage-form">
  <p class="TXT_TITLE">::Manage Information P&A::</p>

  <div class="formStyle">
    <form [formGroup]="manageForm" (ngSubmit)="loadBuyerPna()">
      <div class="form-group">
        <label for="companyCode" class="textColor">Company Code:</label>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Company Code"
          formControlName="companyCode"
        >
          <nz-option
            *ngFor="let company of companies"
            nzLabel="{{ company.ccnCode }}"
            nzValue="{{ company.ccnCode }}"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-group">
        <label for="purchasingOffice" class="textColor"
          >Purchasing Office:</label
        >

        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Purchasing Office"
          formControlName="purchasingOffice"
        >
          <nz-option
            *ngFor="let office of purchasingOffices"
            nzLabel="{{ office.purchasingName }}"
            nzValue="{{ office.purchasingName }}"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-group">
        <label for="status" class="textColor">Status:</label>

        <nz-select
          nzShowSearch
          nzPlaceHolder="Select Status"
          formControlName="status"
        >
          <nz-option
            *ngFor="let status of statuses"
            nzLabel="{{ status }}"
            nzValue="{{ status }}"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-group">
        <label for="pnaNo" class="textColor">P&A No.:</label>

        <div class="pna-search">
          <input
            type="text"
            nz-input
            placeholder=" Enter P&A number"
            formControlName="pnaNo"
          />
          <button nz-button nzType="primary" type="submit">SEARCH</button>
        </div>
        <div
          *ngIf="
            manageForm.controls['pnaNo'].invalid &&
            manageForm.controls['pnaNo'].touched
          "
          class="error-message"
        >
          P&A No. must be a number.
        </div>
      </div>
    </form>
  </div>

  <nz-table
    #requestsData
    nzBordered
    class="StyleTable"
    [nzData]="requests"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="[10, 20, 50, 100]"
    (nzPageSizeChange)="onPageSizeChange($event)"
    (nzPageIndexChange)="onPageIndexChange($event)"
    [nzNoResult]="customNoDataMessage"
  >
    <thead>
      <tr>
        <th></th>
        <th></th>
        <th>P&A No.</th>
        <th>CCN</th>
        <th>Purchasing Office</th>
        <th>Buyer</th>
        <th>Request By</th>
        <th>Status</th>
        <th>Create Date</th>
        <th>Last Updated Date</th>
        <th>Attachment</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let request of requestsData.data">
        <td>
          <a
            (click)="navigateToView(request.pnaNo, request.pnaYear)"
            style="cursor: pointer"
          >
            <img src="../../../../assets/icons/rights.gif" alt="View Item" />
          </a>
        </td>
        <td>
          <a
            (click)="navigateToEdit(request.pnaNo, request.pnaYear)"
            *ngIf="
              getStatusFlags(request.pnaStatus).inProgress ||
              getStatusFlags(request.pnaStatus).isPartiallyQuoted
            "
            style="cursor: pointer"
          >
            <img src="../../../../assets/icons/edit.gif" alt="Edit Item" />
          </a>
        </td>
        <td class="text-left">{{ request.pnaNo }}-{{ request.pnaYear }}</td>
        <td>{{ request.pnaCcn }}</td>
        <td>{{ request.pnaPurchasing }}</td>
        <td class="text-left">{{ request.pnaBuyerFullName | uppercase }}</td>
        <td class="text-left">{{ request.pnaRequestor | uppercase }}</td>
        <td>{{ request.pnaStatus }}</td>
        <td>{{ request.pnaCreateDate | customDate }}</td>
        <td>{{ request.pnaUpdateDate | customDate }}</td>
        <td>
          <ng-container *ngIf="request.hasAttachment">
            <img src="../../../assets/attach_icon.gif" alt="Attachment Icon" />
          </ng-container>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
